import React from 'react';
import { Text } from 'react-native';

export default function CloseEarlyButton() {
  return (
    <Text
      style={{
        fontSize: 20,
        color: '#f1f1f1',
        marginBottom: 2,
      }}
    >
      ✕
    </Text>
  );
}
